module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAS1JREFUSInVlT12gzAQhGeJ72VxItHAcxVJVH6kIScCHyxMCn6NwZIITaYTkuaTltUu8N8ly0GZ64YCFWVAtBR5mKq2bwGuyCxAI0QbA5gPJG4LcplPwisF+Pz6TmMAy8O5IsMaksSabclUte1vTrOeOwWwlL1lKhqw3rQlijy2vnsB9pYp6di4QrOPdZy8gORnGVeaMtfNqYDJOpG0z3moMtdNSNiiAPZet30Ki6NASRf2IA9nkZDXkHUX/5JZZa4bggoAug9xpwJcoUkAeyVhT94QPed3nDkQcANT1dbestbe6zbGeFTYSz5oHgz4i6KyaHxc0kEN5V0xkfTdDXcBo9lYKihQ6DjNU/puZjzhewFMbXMw49Dzxk435n/of3kBUKCOmnnXhhawmP2/JA6RHwOXWyIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/icon2.png
// module id = 1B7V
// module chunks = 1